<template>
  <div class="text-base">
    <div class="relative rounded-md bg-yellow-50 p-4">
      <div class="flex">
        <div class="flex-shrink-0">
          <icon
            set="solid"
            name="exclamation"
            class="flex-shrink-0 h-5 w-5 text-yellow-400"
          />
        </div>
        <div class="ml-3 space-y-2">
          <h3 class="text-sm leading-5 font-medium text-yellow-700">
            <div class="whitespace-pre-wrap">
              The supplier for Dropship variant {{ variantIds }} is no longer
              shipping this size. Reshipment is not available.
            </div>
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoLongerSellingAlert",
  props: {
    selectedForProcessing: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  computed: {
    variantIds() {
      return this.selectedForProcessing
        .filter(item => item.dropship && !item.sellingOnWebsite)
        .map(item => item.variant_id)
        .join(", ");
    }
  },
  watch: {},
  created() {},
  methods: {}
};
</script>
